import type {ReactElement} from 'react';
import {Text, TextSize, TextTag} from '@Components/text';
import {EventPromotionLink} from '../event-promotion-link/event-promotion-link';
import {TICKETING_LOGIN_SECTION_BACKGROUND_STYLE, TICKETING_LOGIN_VISUAL_HEIGHT, TICKETING_LOGIN_VISUAL_URL, TICKETING_LOGIN_VISUAL_WIDTH} from './ticketing-login-section.types';
import styles from './ticketing-login-section.module.scss';

/** The promo that replaces the AI slides on the login page for visitors who can sell tickets: heading, pitch and the event page illustration. */
export function TicketingLoginSection(): ReactElement {
  return (
    <div className={styles.ticketingLoginSection} style={TICKETING_LOGIN_SECTION_BACKGROUND_STYLE}>
      <EventPromotionLink />
      <div className={styles.ticketingContentColumn}>
        <Text val={window.i18next.t('pmwjs_start_selling_tickets')} className={`_unmargin ${styles.ticketingHeading}`} tag={TextTag.H2} />
        <Text val={window.i18next.t('pmwjs_low_fees_more_revenue_ticketed_event')} size={TextSize.LG} className={styles.ticketingSubheading} />
        <img
          alt={window.i18next.t('pmwjs_event_page_with_ticket_qr_code_sales_and_earnings')}
          className={styles.ticketingVisual}
          height={TICKETING_LOGIN_VISUAL_HEIGHT}
          src={TICKETING_LOGIN_VISUAL_URL}
          width={TICKETING_LOGIN_VISUAL_WIDTH}
        />
      </div>
    </div>
  );
}
